import { render, staticRenderFns } from "./view.vue?vue&type=template&id=155c2400&"
import script from "./view.vue?vue&type=script&lang=ts&"
export * from "./view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports